// The pieces that wait on a square they left. A spell that moves pieces in
// steps changes the board at once. The narrator keeps each piece on its first
// square here until the beat of its step starts, and the board reads the map.
// This is presentation: the game state does not know about it.

import type { PieceMove } from '../game/state';
import { createStore } from '../lib/store';

/** The id of a piece, and the square where the board draws it. */
export const waitingPiecesStore = createStore<ReadonlyMap<number, number>>(new Map());

export const keepPiecesWaiting = (moves: readonly PieceMove[]): void => {
  const next = new Map(waitingPiecesStore.get());
  for (const move of moves) next.set(move.pieceId, move.from);
  waitingPiecesStore.set(next);
};

export const letPiecesGo = (moves: readonly PieceMove[]): void => {
  const next = new Map(waitingPiecesStore.get());
  for (const move of moves) next.delete(move.pieceId);
  waitingPiecesStore.set(next);
};

export const letAllPiecesGo = (): void => {
  if (waitingPiecesStore.get().size > 0) waitingPiecesStore.set(new Map());
};
